import urlResolver from 'edrolo/utils/URLResolver';
import AppContainer from 'edrolo/domains/app/components/AppContainer';
import { Lesson } from '../../types/Lesson';

const NotebookPageBreadcrumbs = ({
  classId,
  lesson,
  isTeacherView,
}: NotebookPageTopBarProps) => {
  const rootCrumb = isTeacherView ? (
    <AppContainer.Crumb url={urlResolver.reverse('classes')} anchor>
      My classes
    </AppContainer.Crumb>
  ) : (
    <AppContainer.Crumb url={urlResolver.reverse('courses-page')} anchor>
      My subjects
    </AppContainer.Crumb>
  );

  if (!lesson) {
    return <AppContainer.Breadcrumbs>{rootCrumb}</AppContainer.Breadcrumbs>;
  } // lesson is not loaded

  const lessonLinkUrl = urlResolver.reverse('chunkview-chunk', {
    classId,
    lessonId: lesson.get('id'),
    index: 1,
  });

  return (
    <AppContainer.Breadcrumbs>
      {rootCrumb}

      <AppContainer.Crumb
        url={urlResolver.reverse('course-page', {
          classId,
        })}
      >
        {lesson.get('course_title')}
      </AppContainer.Crumb>

      <AppContainer.Crumb url={lessonLinkUrl}>
        {lesson.get('title')}
      </AppContainer.Crumb>
    </AppContainer.Breadcrumbs>
  );
};

const NotebookPageTopBar = ({
  classId,
  lesson,
  isTeacherView,
}: NotebookPageTopBarProps): JSX.Element => (
  <AppContainer.TopBar>
    <AppContainer.EdroloLogo />
    <NotebookPageBreadcrumbs
      isTeacherView={isTeacherView}
      classId={classId}
      lesson={lesson}
    />
    <AppContainer.ProfileNav />
  </AppContainer.TopBar>
);

export default NotebookPageTopBar;

interface NotebookPageTopBarProps {
  classId: ClassId;
  lesson: Lesson;
  isTeacherView: boolean;
}
